<template>
    <div v-on:click.self="closeModal" class="modal--wrapper" :class="{'modal-open': modalOpenState}">
      <div class="modal modal-forget">
        <div class="modal--title">
          <div class="modal--title-text">{{$t('privacy.title.forgetData.uSure')}}</div>
          <div class="modal--title-actions">
            <modal-close-btn  @click="closeModal"/>
          </div>
          <div class="row row-padding">
            <p>{{$t('privacy.title.forgetData.irremediable')}}</p>
            <p>{{$t('privacy.title.forgetData.noAccess')}}</p>
            <p class="error">{{ReqResponse}}</p>
          </div>
        </div>
        <div class="modal--content" v-if="loading">
          <div class="loader">
            <loader/>
          </div>
        </div>
        <div class="modal--footer" v-else>
          <button class="card-button" @click="closeModal">{{$t('privacy.title.forgetData.cancel')}}</button>
          <button class="card-button" @click="sendRequest" :disabled="this.forgetsResponse.done === false">{{$t('privacy.title.forgetData.validate')}}</button></div>
      </div>
  </div>
</template>

<script>
  import loader from './loader.component';
  import {mapState} from "vuex";
  import ModalCloseBtn from "./modal-close-btn";

  export default {
    name: "validation-modal",
    components: {ModalCloseBtn, loader },
    async mounted() {
      window.addEventListener('app:validation-modal.open', () => {
        this.openModal();
      });
    },
    data() {
      return {
        modalOpenState: false,
        ReqResponse: "",
      }
    },
    computed: {
      ...mapState({
        loading: s => s.client.loading,
        forgetsResponse: state => state.privacyPage.forgetsResponse,
      })
    },
    methods: {
      closeModal() {
        this.modalOpenState = false;
      },
      openModal() {
        this.modalOpenState = true;
      },
      async sendRequest() {
        await this.$store.dispatch('privacyPage/forgetRequest');
        if (this.forgetsResponse)
        {
          this.ReqResponse = this.$t('privacy.title.forgetData.okResponse')
        }
        if (this.forgetsResponse.done === false) {
          this.ReqResponse = this.$t('privacy.title.forgetData.alreadyResponse');
        }
        setTimeout(() => this.modalOpenState = false, 5000);
      }
    },
  };
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/validation-modal.vue